import React, { Component } from 'react';
import URLSearchParams from 'url-search-params';
import PropsRoute from '../../hoc/PropsRoute/PropsRoute';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Auxi from '../../hoc/Auxi/Auxi';
import ContactUsModal from '../../components/Modals/ContactUsModal/ContactUsModal';
import IndexPage from '../IndexPage/IndexPage';
import { nbsApiContactUs } from '../../store/actions/contactUs';
import strings from '../../assets/localization';
import config from '../../constants/config';
import paths from '../../constants/paths';

export const QUERY_PARAM_DELETE_ACCOUNT = 'delete-account';

class ContactUsContainer extends Component {
  constructor(props) {
    super(props);

    let preSelectValue = strings.subject0;

    const { search } = this.props.location;
    const query = new URLSearchParams(search);
    if (query.has(QUERY_PARAM_DELETE_ACCOUNT)) {
      query.delete(QUERY_PARAM_DELETE_ACCOUNT);
      preSelectValue = strings.subject4;
    }

    this.state = {
      showAlert: false,
      alertMessage: null,
      showSpinner: false,
      isSuccess: false,
      preSelectValue,
    };
  }

  componentDidUpdate(prevProps) {
    // Handle loading spinner when fetching
    if (this.props.contactUs.isFetching !== prevProps.contactUs.isFetching) {
      this.setState({ showSpinner: this.props.contactUs.isFetching });
    }

    // Handle success response
    if (
      this.props.contactUs.status === 'success' &&
      prevProps.contactUs.status !== 'success'
    ) {
      this.toggleAlert(strings.AlertMsgSentSuccessfully);
      this.setState({ isSuccess: true });
    }

    // Handle failure response
    if (
      this.props.contactUs.status === 'fail' &&
      prevProps.contactUs.status !== 'fail'
    ) {
      this.toggleAlert(this.props.contactUs.error.error);
    }
  }

  goBack = () => {
    const { history } = this.props;
    if (history.action === 'PUSH') {
      history.goBack();
    } else {
      history.push(paths.INDEX);
    }
  };

  sendMsg = (email, message, subject) => {
    const obj = {
      device_type: 3,
      os_version: navigator.platform,
      app_version: config.VERSION,
      contact_email: email,
      subject,
      message,
      ...(this.props.session.token && { sess_token: this.props.session.token }),
    };
    this.props.nbsApiContactUs(obj);
  };

  toggleAlert = (alertMessage) => {
    this.setState({ showAlert: !this.state.showAlert, alertMessage });
    if (this.state.isSuccess) {
      this.goBack();
    }
  };

  render() {
    return (
      <Auxi>
        {this.props.isLandscape && !this.props.noBack ? (
          <PropsRoute
            isLandscape={this.props.isLandscape}
            component={IndexPage}
          />
        ) : null}
        <ContactUsModal
          showSpinner={this.state.showSpinner}
          sendMsg={this.sendMsg}
          showErrorAlert={this.state.showAlert}
          alertMessage={this.state.alertMessage}
          dismissAlert={this.toggleAlert}
          goBack={this.goBack}
          preSelectValue={this.state.preSelectValue}
          myProfile={this.props.getMyProfile.response}
        />
      </Auxi>
    );
  }
}

function mapStateToProps(state) {
  return {
    contactUs: state.contactUs,
    session: state.session,
    getMyProfile: state.getMyProfile,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiContactUs,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsContainer);
